module.exports = __webpack_public_path__ + "static/img/setting_active.083709e7.svg";